module.exports = __webpack_public_path__ + "img/04b61.2cd5a951.svg";